<template>
  <div id="app" class="app-layout">
    <!-- Sidebar (only show when authenticated and not on login page) -->
    <AdminSidebar v-if="isAuthenticated && !isLoginPage" />

    <!-- Mobile hamburger button (fixed position, always accessible) -->
    <button
      v-if="isAuthenticated && !isLoginPage"
      class="mobile-menu-btn"
      aria-label="Open menu"
      @click="toggleSidebar"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="3" y1="6" x2="21" y2="6"></line>
        <line x1="3" y1="12" x2="21" y2="12"></line>
        <line x1="3" y1="18" x2="21" y2="18"></line>
      </svg>
    </button>

    <!-- Mobile sidebar backdrop -->
    <div
      v-if="isAuthenticated && !isLoginPage"
      class="sidebar-backdrop"
      :class="{ visible: sidebarOpen }"
      @click="closeSidebar"
    ></div>

    <!-- Main Content -->
    <main class="main-content" :class="{ 'full-width': !isAuthenticated || isLoginPage }">
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AdminSidebar from '@/components/layout/AdminSidebar.vue'

export default {
  name: 'App',
  components: {
    AdminSidebar
  },
  computed: {
    ...mapState({
      user: state => state.user,
      isAuthenticated: state => state.isAuthenticated,
      sidebarOpen: state => state.sidebarOpen
    }),
    isLoginPage() {
      return this.$route.name === 'LoginView'
    }
  },
  methods: {
    closeSidebar() {
      this.$store.commit('setSidebarOpen', false)
    },
    toggleSidebar() {
      this.$store.commit('toggleSidebar')
    }
  }
}
</script>

<style>
html, body {
  background-color: var(--bg-primary);
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: var(--text-primary);
  min-height: 100vh;
}

a {
  text-decoration: none;
}

.mobile-menu-btn {
  display: none;
  position: fixed;
  top: 6px;
  left: 8px;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--text-primary);
  cursor: pointer;
  z-index: 60;
}

.sidebar-backdrop {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 150;
}

@media (max-width: 768px) {
  .mobile-menu-btn {
    display: flex;
  }

  .sidebar-backdrop.visible {
    display: block;
  }
}
</style>

<style lang="scss">
@import "assets/theme.scss";
</style>
